// extracted by mini-css-extract-plugin
export default {"root":"documents-header_root__fHLo6","search":"documents-header_search__wHl4p","select":"documents-header_select__2MjJP"};